import React from 'react';

import { link } from './EmailLink.module.css';

export const EmailLink: React.FC = () => (
  <a className={link} href="mailto:contact@jonjames.io">
    contact
  </a>
);
